import React, { PropTypes, Component } from 'react';
import _ from 'underscore';
import { browserHistory } from 'react-router';
import Controls from '../../util/controls';
import { addressFields, addressUpdateStatus } from '../constants/adminConstants';

const propTypes = {
    details: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    onApproval: PropTypes.func.isRequired,
    error: PropTypes.object,
    actioned: PropTypes.bool
};

class AddressUpdate extends Component {
    constructor(props) {
        super(props);

        this.state = { instructions: "" };

        this.renderChange = this.renderChange.bind(this);
        this.updateInstructions = this.updateInstructions.bind(this);

        this.approve = this.approve.bind(this);
        this.reject = this.reject.bind(this);
        this.requireAction = this.requireAction.bind(this);
    }

    renderChange(address = {}) {
        const { details: { changedFields } } = this.props;

        return _.map(addressFields, (field) => {
            const hasChanged = _.any(changedFields, (cf) => cf.toLowerCase() == field.toLowerCase());
            const value = address[field];

            if (!value && !hasChanged)
                return null;

            return (
                <p key={field} className={`change-line ${hasChanged ? "modified" : ""}`}>
                    {address[field]}
                </p>
            );
        });
    }

    onContactUs() {
        browserHistory.push('/contactus');
    }

    approve() {
        const { onApproval } = this.props;

        onApproval({ status: addressUpdateStatus.approved });
    }

    reject() {
        const { onApproval } = this.props;

        if (window.confirm("The job will be cancelled if you choose to proceed. Are you sure?"))
            onApproval({ status: addressUpdateStatus.rejected });
    }

    requireAction() {
        const { onApproval } = this.props;

        onApproval({ status: addressUpdateStatus.actionRequired, comments: this.state.instructions });
    }

    updateInstructions(event) {
        this.setState({ instructions: event.target.value });
    }

    render() {
        const { details: { oldAddress, newAddress }, loading, actioned, error } = this.props;
   
        return (
            <div className="container text-center">
                <div className="jumbotron text-center">
                    <h2 className="m-t-10">Merchant Address Update</h2>
                    {loading || error || actioned ? (
                        <div>
                            {loading && (<Controls.LoadingPanel />)}
                            {error && (<div>
                                <p>{error.statusText}</p>
                                <button type="button" className="btn btn-client btn-lg btn-block" onClick={this.onContactUs}>Contact Us</button>
                            </div>)}
                            {actioned && (
                                <div>
                                    <p><i className="fa fa-check-square fa-4x" /></p>
                                    <p>Your response has been submitted!</p>
                                </div>
                            )}
                        </div>
                    ) : (
                            <div>
                                <h3>{(newAddress || {}).name}</h3>
                                <div className="row m-30">
                                    <div className="col-md-5">
                                        <div className="change previous">
                                            {this.renderChange(oldAddress)}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <i className="fa fa-arrow-right fa-4x arrow" />
                                    </div>
                                    <div className="col-md-5">
                                        <div className="change new">
                                            {this.renderChange(newAddress)}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-offset-3 col-md-6">
                                        <div className="row">
                                            <button type="button" className="btn btn-success btn-lg btn-approval m-l-10 m-r-10" onClick={this.approve}>
                                                Approve
                                            <p className="f-s-13 m-0 p-t-5">Changes will be accepted!</p>
                                            </button>
                                            <button type="button" className="btn btn-danger btn-lg btn-approval m-l-10 m-r-10" onClick={this.reject}>
                                                Reject
                                            <p className="f-s-13 m-0 p-t-5">This will cancel the job!</p>
                                            </button>
                                        </div>
                                        <h3>...or tell us more</h3>
                                        <textarea className="form-control" placeholder="Additional Instructions" onChange={this.updateInstructions} value={this.state.instructions} />
                                        <button type="button" className="btn btn-client btn-lg btn-block m-t-10" onClick={this.requireAction}>
                                            Provide Additional Instructions
                                    </button>
                                    </div>
                                </div>
                            </div>
                        )}

                </div>
            </div>
        );
    }
}

AddressUpdate.propTypes = propTypes;

export default AddressUpdate;


// WEBPACK FOOTER //
// ./app/admin/components/addressUpdate.js